import React, { useState } from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link, useLocation, useNavigate, } from "react-router-dom";

export default function NavbarComponent() {
    const location = useLocation();
    const [showCoursesDropdown, setShowCoursesDropdown] = useState(false);
    const navigate = useNavigate();
    const handleContact=()=>{
        navigate('/contactus#contact-forming')
        setTimeout(() => {
            const element = document.getElementById("contact-forming");
            if (element) {
              element.scrollIntoView({ behavior: "smooth" });
            }
          }, 100);
    }
    return (
        <>
            <div className="navbar_upper_design">

                <img
                    src="images/rclogo.png"
                    alt="company logo"
                    style={{ width: '75px', height: 'auto' }}
                />

                <div className="contact_details">
                    {/* <div className="contact-list">
                        <p>
                            <i className="fa-solid fa-location-dot fa_style" style={{ color: '#B80404' }}></i> &nbsp;934 McCowan Road, Toronto M1P 3H6
                        </p>
                    </div> */}
                    <div className="email">
                        <p>
                            <i className="fa fa-envelope fa_style" style={{ color: '#B80404' }}></i> &nbsp;info@rojancanada.com
                        </p>
                    </div>
                    {/* <div className="phoneNo">
                        <p>
                            <i className="fa-solid fa-phone fa_style" style={{ color: '#B80404' }}></i> &nbsp;  +1 (647) 716-1330
                        </p>
                    </div> */}
                </div>
                <div className="social_media">
                    <button className="view-more-btn" onClick={handleContact}>
                        Contact Now
                    </button>
                    {/* <ul className="sm-list">
                        <li className="social_icon"> <a href="https://facebook.com" className="text-light mx-2  "><i className="fa-brands fa-facebook-f " style={{ color: 'black' }}></i></a></li>
                        <li className="social_icon"><a href="https://twitter.com" className="text-light mx-2 "><i className="fa-brands fa-youtube " style={{ color: 'black' }}></i></a></li>
                        <li className="social_icon"><a href="https://youtube.com" className="text-light mx-2 "><i className="fa-brands fa-instagram " style={{ color: 'black' }}></i></a></li>
                        <li className="social_icon"><a href="https://instagram.com" className="text-light mx-2 "><i className="fa-brands fa-twitter " style={{ color: 'black' }}></i></a></li>
                    </ul> */}
                </div>
            </div>
            <div className="navbars">
                <Navbar collapseOnSelect expand='lg' sticky="top" className="navbar-transparenting">
                    <Container className="navbar-navigate">



                        <Navbar.Brand href='/' className="vs_brand">
                            <img
                                src="images/rclogo.png"
                                className='company logo'
                                alt="logo"
                                style={{ width: '70px', height: 'auto' }}
                            />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                        <Navbar.Collapse id="responsive-navbar-nav" className="click-btn">
                            {/* <div className="text-center nav-header">
                                <h6 className="nav-title">BY IMMIGRATION GET HELP</h6>
                            </div> */}
                            <Nav className='list_navbars'>
                                <ul className="list_item d-flex justify-content-center">
                                    <Nav.Link
                                        as={Link}
                                        to='/' className={`nav-item-spacing ${location.pathname === '/' ? 'active' : ''}`}
                                    >
                                        <i className="fa-solid fa-earth-americas nav-icon"></i>Home
                                    </Nav.Link>
                                    <Nav.Link as={Link} to='/aboutus' className={`nav-item-spacing ${location.pathname === '/aboutus' ? 'active' : ''}`}>
                                    <i className="fa-solid fa-earth-americas nav-icon"> </i>About us
                                    </Nav.Link>
                                    {/* <Nav.Link as={Link} to='/visa' className={`nav-item-spacing ${location.pathname === '/visa' ? 'active' : ''}`}>Visa</Nav.Link>
                                    <Nav.Link as={Link} to='/country' className={`nav-item-spacing ${location.pathname === '/country' ? 'active' : ''}`}>Country</Nav.Link> */}
                                    <NavDropdown
                                     title={
                                        <>
                                          <i className="fa-solid fa-earth-americas nav-icon"> </i>Our Services
                                        </>
                                      }
                                        id="service-dropdown"
                                        className={`nav-item-spacing navigators ${location.pathname.includes('/service') ? 'active' : ''}`}
                                        onMouseEnter={() => setShowCoursesDropdown(true)}
                                        onMouseLeave={() => setShowCoursesDropdown(false)}
                                        show={showCoursesDropdown}
                                    >
                                        <NavDropdown.Item as={Link} to="/vendor-management" className="nav-item-listing">
                                        <span class="dropdown-arrow">➤</span> Vendor Management & Strategic Pricing</NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/budgeting-overseeing">
                                        <span class="dropdown-arrow">➤</span> Budget Planning & Financial Oversight</NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/advertisementplan-strategies">
                                        <span class="dropdown-arrow">➤</span> Marketing & Advertising Strategy</NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/administration-staffing">
                                        <span class="dropdown-arrow">➤</span> Administration & Staffing Solutions</NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/restaurant-management">
                                        <span class="dropdown-arrow">➤</span> Restaurant Business Consulting</NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/immigration-services">
                                        <span class="dropdown-arrow">➤</span> Immigration & Visa Support Services</NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/import-distribution-delivery">
                                        <span class="dropdown-arrow">➤</span> Import, Distribution & Delivery</NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/marketing-branding">
                                        <span class="dropdown-arrow">➤</span> Social Media & Digital Advertising</NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/label-printing-packaging-services">
                                        <span class="dropdown-arrow">➤</span> Custom Private Label, Printing & Packaging Services</NavDropdown.Item>
                                    </NavDropdown>
                                    <Nav.Link as={Link} to='/contactus' className={`nav-item-spacing ${location.pathname === '/contactus' ? 'active' : ''}`}>
                                    <i className="fa-solid fa-earth-americas nav-icon"> </i>Contact us</Nav.Link>
                                </ul>
                            </Nav>
                            {/* <div className="book-visit">
                                <button className="book-button">Book a Visit</button>
                            </div> */}
                        </Navbar.Collapse>


                    </Container>
                </Navbar>
            </div>
        </>
    )
}